function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function isiPad() {
  return navigator.userAgent.match(/Mac/)
      && navigator.maxTouchPoints
      && navigator.maxTouchPoints > 2
}

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

module.exports = {
  isMobile,
  isiPad,
  isSafari
}
